import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Check } from "lucide-react";

export default function AdminPackages() {
  const [packages, setPackages] = useState(null);
  useEffect(() => { api.get("/billing/packages").then((r) => setPackages(r.data)); }, []);
  if (!packages) return null;
  return (
    <div data-testid="admin-packages-page" className="space-y-6">
      <h1 className="font-display font-extrabold text-3xl">Packages</h1>
      <div className="grid md:grid-cols-3 gap-4">
        {packages.plans.map((p) => (
          <div key={p.id} className="hs-card p-6">
            <div className="font-display font-bold text-2xl">{p.name}</div>
            <div className="font-display font-extrabold text-3xl mt-2">${p.price_usd}/mo</div>
            <div className="text-xs font-mono text-[#4B5563] mt-1">AI {p.ai_credits} · Voice {p.voice_credits}</div>
            <ul className="text-sm space-y-1.5 mt-4">
              {p.features.map((f) => <li key={f} className="flex items-start gap-2"><Check className="w-4 h-4 text-[#0044FF] mt-0.5" />{f}</li>)}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
